import { StandardEvents } from '@shopify/events';

const root = document.querySelector('ksh-party');
if (root && !root.dataset.ready) {
  root.dataset.ready = 'true';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const storage = {
    get(key) { try { return sessionStorage.getItem(key); } catch { return 'unavailable'; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch {} },
    remove(key) { try { sessionStorage.removeItem(key); } catch {} }
  };
  let layer;
  let cleanupTimer;
  function clearConfetti() { layer?.remove(); layer = null; clearTimeout(cleanupTimer); }
  function celebrate(welcome = false) {
    if (reduced.matches || document.hidden) return;
    clearConfetti();
    layer = document.createElement('div');
    layer.className = 'ksh-confetti';
    layer.setAttribute('aria-hidden', 'true');
    const host = document.querySelector('dialog[open]') || document.body;
    host.append(layer);
    for (let i = 0; i < 42; i++) {
      const piece = document.createElement('i');
      piece.style.background = i % 2 ? '#f18b00' : '#3fae2a';
      const x = welcome ? Math.random() * innerWidth : innerWidth * 0.8;
      const y = welcome ? -20 : Math.min(150, innerHeight * 0.2);
      piece.style.left = `${x}px`;
      piece.style.top = `${y}px`;
      layer.append(piece);
      const spread = (Math.random() - 0.5) * (welcome ? 180 : 650);
      piece.animate([
        { transform:'translate(0,0) rotate(0deg)', opacity:1 },
        { transform:`translate(${spread * 0.5}px,${welcome ? 150 : -70}px) rotate(160deg)`, opacity:1, offset:0.3 },
        { transform:`translate(${spread}px,${Math.min(innerHeight, 650)}px) rotate(${360 + Math.random() * 400}deg)`, opacity:0 }
      ], { duration:1400 + Math.random() * 350, easing:'ease-out', fill:'forwards' });
    }
    cleanupTimer = setTimeout(clearConfetti, 1800);
  }
  reduced.addEventListener('change', clearConfetti);
  const seasonStart = Date.parse(root.dataset.seasonStart);
  const seasonEnd = Date.parse(root.dataset.seasonEnd);
  const toggle = root.querySelector('.ksh-confetti-toggle');
  let snow;
  let santa;
  let currentSeason;
  let santaShown = false;
  let seasonTimer;
  let confettiOff = storage.get('ksh-confetti-off') === '1';
  const holidays = [
    { name:'halloween', start:Date.parse('2026-10-26T00:00:00+01:00'), end:Date.parse('2026-11-01T00:00:00+01:00') },
    { name:'sinterklaas', start:Date.parse('2026-11-29T00:00:00+01:00'), end:Date.parse('2026-12-06T00:00:00+01:00') },
    { name:'christmas', start:Date.parse('2026-12-21T00:00:00+01:00'), end:Date.parse('2026-12-28T00:00:00+01:00') },
    { name:'newyear', start:Date.parse('2026-12-28T00:00:00+01:00'), end:Date.parse('2027-01-02T00:00:00+01:00') }
  ];
  function updateSeason() {
    clearTimeout(seasonTimer);
    const previewDate = new URLSearchParams(location.search).get('ksh_preview_date');
    const previewNow = window.Shopify?.theme?.role === 'unpublished' && previewDate ? Date.parse(previewDate) : NaN;
    const now = Number.isFinite(previewNow) ? previewNow : Date.now();
    const holiday = holidays.find(period => now >= period.start && now < period.end);
    const season = holiday?.name || (now >= seasonStart && now < seasonEnd ? 'carnival' : '');
    document.documentElement.classList.toggle('ksh-halloween', season === 'halloween');
    document.documentElement.classList.toggle('ksh-christmas', season === 'christmas');
    if (season !== currentSeason) {
      snow?.remove(); snow = null;
      santa?.remove(); santa = null;
      currentSeason = season;
    }
    if (toggle) toggle.hidden = !season || reduced.matches;
    if (!season || reduced.matches || confettiOff) {
      snow?.remove(); snow = null;
      santa?.remove(); santa = null;
    } else if (!snow) {
      snow = document.createElement('div');
      snow.className = `ksh-season-confetti ksh-season-${season}`;
      snow.setAttribute('aria-hidden','true');
      for (let i=0; i<(season === 'halloween' ? 12 : 28); i++) {
        const piece = document.createElement('i');
        if (season === 'sinterklaas') {
          piece.className = i % 4 === 0 ? 'ksh-falling-gift' : 'ksh-pepernoot';
          if (i % 4 === 0) piece.textContent = '🎁';
        } else if (season === 'christmas') {
          piece.className = i % 7 === 0 ? 'ksh-falling-gift' : 'ksh-snowflake';
          piece.textContent = i % 7 === 0 ? '🎁' : '❄';
        } else if (season === 'halloween') {
          piece.className = 'ksh-spooky-piece';
          piece.textContent = i % 2 ? '🎃' : '👻';
        } else piece.style.background = i % 2 ? '#f18b00' : '#3fae2a';
        piece.style.setProperty('--x', `${Math.random()*100}%`);
        piece.style.setProperty('--duration', `${12+Math.random()*10}s`);
        piece.style.setProperty('--delay', `${-Math.random()*22}s`);
        piece.style.setProperty('--drift', `${(Math.random()-.5)*150}px`);
        if (season === 'newyear') {
          const angle = (i % 14) * Math.PI * 2 / 14;
          piece.className = 'ksh-firework-spark';
          piece.style.setProperty('--x', i < 14 ? '28%' : '72%');
          piece.style.setProperty('--y', i < 14 ? '30%' : '48%');
          piece.style.setProperty('--dx', `${Math.cos(angle)*100}px`);
          piece.style.setProperty('--dy', `${Math.sin(angle)*100}px`);
          piece.style.setProperty('--delay', i < 14 ? '0s' : '4s');
        }
        snow.append(piece);
      }
      document.body.append(snow);
    }
    if (season === 'christmas' && !santaShown && !reduced.matches && !confettiOff && !document.hidden) {
      santaShown = true;
      santa = document.createElement('div');
      santa.className = 'ksh-flying-santa';
      santa.setAttribute('aria-hidden','true');
      santa.textContent = '🦌 🛷 🎅';
      santa.addEventListener('animationend', () => { santa?.remove(); santa = null; }, { once:true });
      document.body.append(santa);
    }
    if (snow) snow.toggleAttribute('data-paused', document.hidden);
    if (santa) santa.toggleAttribute('data-paused', document.hidden);
    if (toggle) {
      toggle.textContent = confettiOff ? toggle.dataset.on : toggle.dataset.off;
      toggle.setAttribute('aria-pressed', String(!confettiOff));
    }
    const boundaries = [seasonStart, seasonEnd, ...holidays.flatMap(period => [period.start,period.end])];
    const next = Math.min(...boundaries.filter(time => time > now));
    if (Number.isFinite(next)) seasonTimer = setTimeout(updateSeason, Math.min(next-now,3600000));
  }
  toggle?.addEventListener('click', () => {
    confettiOff = !confettiOff;
    storage.set('ksh-confetti-off', confettiOff ? '1' : '0');
    updateSeason();
  });
  reduced.addEventListener('change', updateSeason);
  document.addEventListener('visibilitychange', updateSeason);
  window.addEventListener('pageshow', updateSeason);
  window.addEventListener('pagehide', () => clearTimeout(seasonTimer));
  updateSeason();
  const welcome = root.querySelector('.ksh-welcome');
  if (welcome && new URLSearchParams(location.search).get('spel') !== 'halloween' && new URLSearchParams(location.search).get('spel') !== 'vuurwerk' && !window.Shopify?.designMode && !storage.get('ksh-welcomed-v2')) {
    storage.set('ksh-welcomed-v2', '1');
    welcome.hidden = false;
    const countdown = welcome.querySelector('.ksh-countdown');
    let countdownTimer;
    const tick = () => {
      const preview = window.Shopify?.theme?.role === 'unpublished' ? Date.parse(new URLSearchParams(location.search).get('ksh_preview_date')) : NaN;
      const now = Number.isFinite(preview) ? preview : Date.now();
      const seasonStart = Date.parse(countdown.dataset.target);
      const carnival = now >= seasonStart;
      const target = carnival ? Date.parse(countdown.dataset.carnivalTarget) : seasonStart;
      if (carnival) {
        countdown.querySelector('.ksh-countdown-label').textContent = countdown.dataset.carnivalLabel;
        welcome.querySelector('.ksh-welcome-story').textContent = countdown.dataset.carnivalStory;
      }
      const remaining = Math.max(0, Math.ceil((target - now) / 1000));
      countdown.hidden = false;
      if (!remaining) {
        countdown.textContent = countdown.dataset.started;
        clearInterval(countdownTimer);
        return;
      }
      const values = { days:Math.floor(remaining / 86400), hours:Math.floor(remaining / 3600) % 24, minutes:Math.floor(remaining / 60) % 60, seconds:remaining % 60 };
      for (const [unit,value] of Object.entries(values)) countdown.querySelector(`[data-time="${unit}"]`).textContent = String(value).padStart(2,'0');
    };
    if (countdown) { countdownTimer = setInterval(tick, 1000); tick(); }
    const dismiss = () => { welcome.hidden = true; clearConfetti(); clearInterval(countdownTimer); };
    welcome.addEventListener('click', dismiss);
    document.addEventListener('keydown', dismiss, { once:true });
    if (!reduced.matches) {
      welcome.querySelector('.ksh-welcome-card').animate([
        { transform:'translateY(12px) rotate(-1deg)' },
        { transform:'translateY(0) rotate(0deg)' }
      ], { duration:350, easing:'ease-out' });
      celebrate(true);
    }
    setTimeout(dismiss, 7000);
    window.addEventListener('pagehide', dismiss, { once:true });
  }
  const handled = new WeakSet();
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    if (event.action !== 'add' || !event.promise || handled.has(event.promise)) return;
    handled.add(event.promise);
    event.promise.then(result => {
      if (!result?.detail?.didError) celebrate();
    }).catch(() => {});
  });
  const pending = Number(storage.get('ksh-cart-celebrate'));
  storage.remove('ksh-cart-celebrate');
  if (pending && Date.now() - pending < 15000 && location.pathname.replace(/\/$/, '') === root.dataset.cartUrl.replace(/\/$/, '')) celebrate();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-ksh-form]')) return;
    event.preventDefault();
    if (form.dataset.partyBusy || !form.reportValidity()) return;
    form.dataset.partyBusy = 'true';
    const button = form.querySelector('[type=submit]');
    if (button) button.disabled = true;
    let message = form.querySelector('.ksh-party-error');
    if (message) message.remove();
    try {
      const response = await fetch(`${form.action.replace(/\/$/, '')}.js`, { method:'POST', body:new FormData(form), headers:{ Accept:'application/json' } });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || root.dataset.error);
      storage.set('ksh-cart-celebrate', String(Date.now()));
      location.assign(root.dataset.cartUrl);
    } catch (error) {
      message = document.createElement('p');
      message.className = 'ksh-party-error';
      message.setAttribute('role', 'alert');
      message.textContent = error instanceof Error && error.message !== 'Failed to fetch' ? error.message : root.dataset.error;
      form.append(message);
      delete form.dataset.partyBusy;
      if (button) button.disabled = false;
    }
  });
}


